<template>
    <div class="step-wrapper">
        <div class="step-header">
            <h2 class="step-title">Start your student housing search!</h2>
            <p class="step-subtitle">Select your room preference.</p>
        </div>

        <div class="step-body">
            <CardSelector
                :options="housingOptions"
                :value="selectedValue"
                @input="onSelect"
            />
        </div>

        <div class="step-footer">
            <v-btn
                color="primary"
                depressed
                block
                height="50"
                :disabled="!selectedValue"
                @click="onNext"
                class="next-btn"
            >
                Next
            </v-btn>

            <div class="login-prompt">
                Been here before? <a href="#" @click.prevent="openSignIn">Log In</a>
            </div>
        </div>
    </div>
</template>

<script>
import CardSelector from '../shared/CardSelector.vue';

export default {
    name: 'HousingTypeStep',

    components: {
        CardSelector
    },

    data() {
        return {
            housingOptions: [
                {
                    value: 'private',
                    label: 'Private Room',
                    icon: 'mdi-home-account'
                },
                {
                    value: 'shared',
                    label: 'Shared Room',
                    icon: 'mdi-account-group'
                }
            ]
        };
    },

    computed: {
        selectedValue() {
            return this.$store.getters['Questionnaire/getAnswer']('housingType');
        }
    },

    methods: {
        onSelect(value) {
            this.$store.dispatch('Questionnaire/setAnswer', {
                key: 'housingType',
                value
            });
        },

        onNext() {
            if (this.selectedValue) {
                this.$emit('next');
            }
        },

        openSignIn() {
            this.$store.dispatch('setSignInModal', true);
        }
    }
};
</script>

<style scoped>
.step-wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.step-header {
    text-align: center;
    margin-bottom: 32px;
}

.step-title {
    font-size: 24px;
    font-weight: 700;
    color: #333;
    margin-bottom: 8px;
}

.step-subtitle {
    font-size: 16px;
    color: #666;
}

.step-body {
    flex: 1;
    display: flex;
    align-items: flex-start;
    justify-content: center;
}

.step-footer {
    margin-top: auto;
    padding-top: 24px;
}

.next-btn {
    font-weight: 600;
    text-transform: none;
    font-size: 16px;
    border-radius: 8px;
}

.login-prompt {
    text-align: center;
    margin-top: 16px;
    font-size: 14px;
    color: #666;
}

.login-prompt a {
    color: #2D76E3;
    font-weight: 600;
    text-decoration: none;
}

.login-prompt a:hover {
    text-decoration: underline;
}
</style>
